import { render, staticRenderFns } from "./external-data-table.vue?vue&type=template&id=b3273946&"
import script from "./external-data-table.vue?vue&type=script&lang=js&"
export * from "./external-data-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports